<template>
  <CCol sm="12" md="5" class="columnProperty text-gray-500">
    <CRow class="h-100">
      <CCol class="mt-5">
        <div class="columnProperty__main" :class="{ 'columnProperty__main--edit': property.edit }">
          <div class="columnProperty__header">
            <transition-group name="fade">
              <div key="main" class="d-flex mb-3 text-primary" v-if="property.isKey && property.edit">
                <i class="icon icon__key icon__keyGrayDark mr-1"></i>
                <h5 class="mainColumns__title font-weight-semi-bold text-uppercase">
                  {{ $t('audience.organize.audianceList.header5.keys-columns') }}
                </h5>
              </div>

              <div key="state" class="d-flex justify-content-between align-items-center" v-if="!property.edit">
                <div class="d-flex align-items-center" v-if="property.state.key == 2 || property.state == 4">
                  <i class="columnProperty__icon mr-2 bg-success text-white fas fa-check"></i>
                  <p class="mb-0 font-weight-bold text-gray-700">{{ $t('audience.organize.audianceList.text.confirm-mapping') }}</p>
                </div>

                <div class="d-flex align-items-center" v-if="property.state.key == 3">
                  <i class="columnProperty__icon mr-2 bg-gray-700 text-white fas fa-times"></i>
                  <p class="mb-0 font-weight-bold text-gray-700">{{ $t('audience.organize.audianceList.text.ignored') }}</p>
                </div>

                <CButton
                  class="btn-gray-200 m-1 font-weight-semi-bold"
                  v-show="!property.edit"
                  @click="editColumn({ position: property.fileColumnPosition })"
                >
                  {{ $t('audience.organize.audianceList.button.edit') }}
                </CButton>
              </div>
            </transition-group>
            <div v-if="property.edit">
              <ul class="messages p-0">
                <li v-for="(message, index) in property.messages" :key="index" class="d-flex messageItem d-flex flex-column">
                  <p class="font-weight-bold text-gray-700 d-flex align-items-center" v-if="verifyState.hasDefaultType == true">
                    <i class="columnProperty__icon mr-2 bg-success thead-dark text-white fas fa-check"></i>
                    {{ $t('audience.organize.audianceList.text.match-to') }} {{ property.type.value }}
                    {{ $t('audience.organize.audianceList.text.field') }}
                  </p>
                  <p class="font-weight-bold text-gray-700 d-flex align-items-center" v-else-if="showTextMapping(property)">
                    <i class="columnProperty__icon mr-2 bg-warning text-white fas fa-exclamation"></i>
                    {{ $t('audience.organize.audianceList.text.unable-to-automatically') }}
                  </p>
                  <p class="font-weight-bold text-gray-700 d-flex align-items-center" v-else>
                    <i class="columnProperty__icon mr-2 bg-success text-white fas fa-check"></i>
                    {{ $t('audience.organize.audianceList.text.colum-field') }} <span class="text-uppercase ml-2"> {{ property.type.value }}</span>
                  </p>
                  <p class="font-weight-bold text-gray-700 d-flex align-items-center" v-if="verifyState.hasName">
                    <i class="columnProperty__icon mr-2 text-white bg-danger fas fa-times"></i>
                    {{ $t('audience.organize.audianceList.text.column-dont') }}
                  </p>
                </li>
              </ul>
              <ul class="actions p-0 mb-0">
                <CButton
                  :disabled="isDisableMapping(property)"
                  class="btn-success m-1 font-weight-semi-bold"
                  @click="actionProperty({ state: 2, position: property.fileColumnPosition })"
                >
                  {{ $t('audience.organize.audianceList.button.confirm-mapping') }}
                </CButton>
                <CButton
                  class="btn-outline-gray-500 m-1 font-weight-semi-bold"
                  @click="actionProperty({ state: 3, position: property.fileColumnPosition })"
                >
                  {{ $t('audience.organize.audianceList.button.ignore-column') }}
                </CButton>
              </ul>
            </div>
          </div>
        </div>
      </CCol>
    </CRow>
  </CCol>
</template>

<script>
export default {
  name: 'AudienceListColumnProperty',
  props: {
    property: {
      type: Object,
      required: true,
    },
    types: {
      type: Array,
      required: true,
    },
  },
  methods: {
    convertForColor(state) {
      const stateList = {
        0: 'edit',
        1: 'success',
        2: 'info',
        3: 'warning',
        4: 'danger',
      }

      return stateList[state]
    },

    showTextMapping(property) {
      if (property.type == null) {
        return true
      }

      if (property.type.group == 'new' && property.type.hasName == false) {
        return true
      }

      if ((property.type.dataType.key == 3 || property.type.dataType.key == 5) && property.type != null) {
        if (property.format) {
          return false
        }
        return true
      }

      // return property.state.key == 2 || property.state == 4

      // if(prop.type.dataType.key != 5 || prop.type.dataType.key != 3) {
      //

      // }
    },

    isDisableMapping(prop) {
      if (!prop.type || !prop.type.key) {
        return true
      }

      if (prop.type.group == 'new' && prop.type.hasName == false) {
        return true
      }

      if ((prop.type.dataType.key == 5 || prop.type.dataType.key == 3) && prop.format == undefined) {
        return true
      }

      return false
    },

    editColumn(column) {
      this.$store.dispatch('audience/editColumn', column)
    },

    actionProperty(payload) {
      this.$store.dispatch('audience/actionProperty', payload)
    },
  },
  computed: {
    verifyState() {
      return {
        hasName: this.property.fileColumnName == '' ? true : false,
        hasType: this.property.type !== null ? true : false,
        hasDefaultType: this.property.type !== null ? this.types.includes(this.property.type.value) : false,
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.columnProperty {
  padding-left: 40px;

  &__main {
    border: 1px solid var(--gray-500);
    padding: 0.5rem 0.5rem 0.5rem 1.5rem;

    &--edit {
      padding: 1.5rem;
    }
  }

  &__messages {
  }

  &__icon {
    width: 20px;
    height: 20px;
    border-radius: 20px;
    display: block;
    line-height: 20px;
    font-size: 12px;
    text-align: center;
  }

  p {
    margin-bottom: 0;
  }

  &__messageItem {
  }
}
</style>
